const availableRolesHelper = [
    {
        value: 'ROLE_CONTRACTOR',
        label: 'Contratante'
    },
    {
        value: 'ROLE_PROFESSIONAL',
        label: 'Prestador'
    }
]

export default availableRolesHelper
